import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import dict from './dict'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    dict,
    verticalMenu,
  },
  strict: process.env.DEV,
})
